var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"items-list"},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"item"},[_c('nuxt-link',{key:item.id,attrs:{"to":_vm.itemLink(item.id)}},[_vm._v(_vm._s(item.name))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }